// extracted by mini-css-extract-plugin
export default {"l":"ed667d2715"};